import cx from "classnames";

export type TabStatus = "active" | "disabled";
export type TabProps = {
  name: string;
  status?: TabStatus;
};

const Tab = ({ name, status }: TabProps) => {
  const isActive = status === "active";

  return (
    <li className="flex flex-1 flex-col items-center gap-1.5 px-1 text-center">
      <span
        className={cx("whitespace-nowrap text-xs tracking-wide transition-colors lg:text-sm", {
          "font-semibold text-tim-primary": isActive,
          "font-normal text-gray-400": !isActive,
        })}
      >
        {name}
      </span>
      <div
        className={cx("h-1 w-full rounded-full transition-colors", {
          "bg-tim-primary": isActive,
          "bg-gray-200": !isActive,
        })}
      />
    </li>
  );
};

export default Tab;
